export default "__VITE_ASSET__D1mGlu1U__"